import {
  Bone,
  FieldSkeleton,
  HeaderSkeleton,
  Line,
  PanelSkeleton,
  pick,
  placeholderKeys,
  SkeletonRegion,
  TableSkeleton,
} from '@ems/ui/patterns/skeleton-blocks'

export function MembersSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-28" description="w-80" />
      <PanelSkeleton title="w-32">
        <div className="grid gap-4 sm:grid-cols-[1fr_14rem_auto] sm:items-end">
          <FieldSkeleton label="w-12" />
          <FieldSkeleton label="w-10" control="select" />
          <Bone className="h-9 w-16" />
        </div>
        <FieldSkeleton control="checkbox" label="w-48" help="w-72" />
      </PanelSkeleton>
      <TableSkeleton
        columns={[
          { cell: 'two-line', widths: ['w-36', 'w-48', 'w-28', 'w-40'], primary: true },
          { cell: 'select' },
          { cell: 'badge', widths: ['w-16', 'w-20'] },
          { cell: 'muted', widths: ['w-24', 'w-28'] },
          { cell: 'button', widths: ['w-20'], header: null, align: 'end', shrink: true },
        ]}
      />
    </SkeletonRegion>
  )
}

const ROLE_KEYS = placeholderKeys('role', 4)
const PERMISSION_KEYS = placeholderKeys('permission', 6)
const PERMISSION_WIDTHS = ['w-32', 'w-40', 'w-28', 'w-36'] as const

export function RolesSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-20" description="w-72" actions={['h-8 w-24']} />
      <div className="grid gap-6 lg:grid-cols-[18rem_1fr]">
        <ul className="flex flex-col gap-1">
          {ROLE_KEYS.map((key, at) => (
            <li
              key={key}
              className="flex flex-col items-start gap-1 rounded-md border border-transparent px-3 py-2"
            >
              <Line width={pick(['w-24', 'w-32', 'w-20'], at)} />
              <Line size="xs" width="w-40" />
            </li>
          ))}
        </ul>
        <PanelSkeleton title="w-32" className="gap-0">
          <div className="mt-4 flex flex-col gap-6">
            <div className="grid gap-4 sm:grid-cols-2">
              <FieldSkeleton label="w-12" />
              <FieldSkeleton label="w-8" />
            </div>
            <div className="rounded-md border border-(--border) p-4">
              <FieldSkeleton control="checkbox" label="w-40" help="w-64" className="py-0" />
            </div>
            <div className="overflow-hidden rounded-md border border-(--border)">
              {PERMISSION_KEYS.map((key, at) => (
                <div
                  key={key}
                  className="flex items-center gap-6 border-b border-(--border) px-4 py-2 last:border-b-0"
                >
                  <Line width={pick(PERMISSION_WIDTHS, at)} className="flex-1" />
                  <Bone className="size-4 shrink-0" />
                  <Bone className="size-4 shrink-0" />
                  <Bone className="size-4 shrink-0" />
                </div>
              ))}
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <Bone className="h-9 w-28" />
            </div>
          </div>
        </PanelSkeleton>
      </div>
    </SkeletonRegion>
  )
}
